import { CheckCircle, Circle, Loader2, XCircle } from 'lucide-react';
import type { SandboxProgress } from '@/api/sandbox';

interface Step {
  key: keyof SandboxProgress;
  label: string;
}

const STEPS: Step[] = [
  { key: 'initializing', label: 'Initializing sandbox' },
  { key: 'storageAccessPoint', label: 'Setting up storage access' },
  { key: 'storageVolumes', label: 'Creating storage volumes' },
  { key: 'podCreating', label: 'Creating sandbox environment' },
  { key: 'podStarting', label: 'Starting sandbox' },
  { key: 'ready', label: 'Sandbox ready' },
];

interface ProgressStepsProps {
  progress?: SandboxProgress;
}

export function ProgressSteps({ progress }: ProgressStepsProps) {
  return (
    <div className="w-full max-w-md space-y-3 text-left">
      {STEPS.map((step) => {
        const stepProgress = progress?.[step.key];
        const status = stepProgress?.status || 'pending';

        return (
          <div key={step.key} className="flex items-center gap-3">
            {/* Icon based on status */}
            {status === 'completed' && (
              <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" />
            )}
            {status === 'in_progress' && (
              <Loader2 className="w-5 h-5 text-blue-500 animate-spin flex-shrink-0" />
            )}
            {status === 'failed' && (
              <XCircle className="w-5 h-5 text-red-500 flex-shrink-0" />
            )}
            {status === 'pending' && (
              <Circle className="w-5 h-5 text-gray-300 flex-shrink-0" />
            )}

            {/* Label */}
            <span
              className={
                status === 'completed'
                  ? 'text-green-700 font-medium'
                  : status === 'in_progress'
                  ? 'text-blue-700 font-medium'
                  : status === 'failed'
                  ? 'text-red-700 font-medium'
                  : 'text-gray-500'
              }
            >
              {step.label}
            </span>
          </div>
        );
      })}
    </div>
  );
}
